import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService, UserService } from '../../shared';
import { User } from '../../models/user';
import { ConfigService } from '../../shared/services/config.service';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'app-edituser',
  templateUrl: './edit.user.component.html',
  styleUrls: ['./edit.user.component.css'],
  providers: [UserService],
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatTab,
    MatTabGroup,
    MatInput,
    MatButton,
    FlexModule,
    MatError,
    MatLabel,
    ReactiveFormsModule
  ]
})
export class EditUserComponent implements OnInit {
  user: User;

  emailError: string;

  form = new FormGroup({
    name: new UntypedFormControl('', Validators.required),
    user_name: new UntypedFormControl(''),
    email: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl(''),
    password_confirmed: new UntypedFormControl('')
  });

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let id = params['userId'];
      this.userService.get(id).subscribe(
        (response) => {
          this.form.patchValue({
            ...response,
            password: '',
            password_confirmed: ''
          });
          this.user = response;
        },
        (error) => {}
      );
    });
  }

  save(password: boolean) {
    const payload = this.form.value;
    if (!password) {
      delete payload.password;
      delete payload.password_confirmed;
    } else {
      if (!payload.password) {
        this.form.controls['password'].setErrors({
          required: 'Password is required'
        });
        this.form.controls['password'].markAllAsTouched();
        return;
      }
      if (payload.password !== payload.password_confirmed) {
        this.form.controls['password'].setErrors({
          mismatch: 'Passwords do not match'
        });
        this.form.controls['password'].markAllAsTouched();
        this.form.controls['password_confirmed'].markAllAsTouched();
        return;
      }
    }
    this.userService.update(this.user.id, payload).subscribe(
      (response) => {
        this.backToList();
      },
      (error) => {
        if (error.status === 409 && error.error.message) {
          this.form.controls['email'].setErrors({
            conflict: error.error.message
          });
        }
      }
    );
  }

  backToList() {
    this.router.navigate(['users']);
  }
}
